import {Misc} from "../lexer";
import {HoverPattern, makeHoverPattern} from "./utils";
import {IdentTree, MethodInvocationTree, StringLiteralTree} from "../model";

const nullLiteral = makeHoverPattern([Misc.null] as const, (_chain, a) => {
	return `The <code>null</code> keyword represents the absence of an object.`;
});

const hexFloatLiteral = makeHoverPattern(
	[Misc.floatLiteral] as const,
	(_chain, scope, a) => {
		if (a.isHexFloat && Number.isFinite(a.value))
			return `Decimal value: <code>${a.value}</code>`;
		return null;
	}
);

const setImage = makeHoverPattern(
	[MethodInvocationTree, StringLiteralTree, Misc.string] as const,
	(_chain, scope, method, b, d) => {
		if (
			method.ident instanceof IdentTree &&
			method.ident.identifier === "setImage" &&
			d.value.match(/^[a-zA-Z0-9.-]*$/)
		) {
			return `<img src="https://cs-curriculum-assets.artofproblemsolving.com/PixiSprites/${d.value}" width="200" />`;
		}
		return null;
	}
);

export const LITERALS_HOVERS: HoverPattern<any, any>[] = [
	nullLiteral,
	hexFloatLiteral,
	setImage,
];
